import { useContext } from 'react';
import { AppBannerContext } from '../contexts/app_banner.context';
export const useAppBanner = () => {
    const context = useContext(AppBannerContext);
    if (!context) {
        throw new Error('useAppBanner must be used within a AppBannerProvider');
    }
    return context;
};
